"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CollapsibleSidebar = function CollapsibleSidebar(_ref) {
  var label = _ref.label,
      children = _ref.children,
      open = _ref.open,
      selectAll = _ref.selectAll,
      onSelectAllClick = _ref.onSelectAllClick,
      onDeselectAllClick = _ref.onDeselectAllClick,
      isAllSelected = _ref.isAllSelected,
      _ref$hideText = _ref.hideText,
      hideText = _ref$hideText === void 0 ? 'Hide' : _ref$hideText,
      _ref$showText = _ref.showText,
      showText = _ref$showText === void 0 ? 'Show' : _ref$showText,
      _ref$selectAllText = _ref.selectAllText,
      selectAllText = _ref$selectAllText === void 0 ? 'Select all' : _ref$selectAllText,
      _ref$deselectAllText = _ref.deselectAllText,
      deselectAllText = _ref$deselectAllText === void 0 ? 'Deselect all' : _ref$deselectAllText,
      hideButton = _ref.hideButton;

  var _useState = (0, _react.useState)(open),
      _useState2 = _slicedToArray(_useState, 2),
      SideBarOpen = _useState2[0],
      setSideBarOpen = _useState2[1];

  var handleToggle = function handleToggle() {
    setSideBarOpen(!SideBarOpen);
  };

  return /*#__PURE__*/_react.default.createElement(Sidebar, null, /*#__PURE__*/_react.default.createElement(SidebarHeader, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "title"
  }, label), !hideButton && (selectAll ? /*#__PURE__*/_react.default.createElement(SidebarToggle, {
    onClick: function onClick(args) {
      return isAllSelected ? onDeselectAllClick(args) : onSelectAllClick(args);
    }
  }, isAllSelected ? deselectAllText : selectAllText) : /*#__PURE__*/_react.default.createElement(SidebarToggle, {
    onClick: handleToggle
  }, SideBarOpen ? hideText : showText))), /*#__PURE__*/_react.default.createElement(SidebarContent, {
    open: SideBarOpen
  }, children));
};

var Sidebar = _styledComponents.default.div.withConfig({
  displayName: "Sidebar"
})(["width:100%;font-family:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var SidebarHeader = _styledComponents.default.div.withConfig({
  displayName: "SidebarHeader"
})(["display:flex;justify-content:space-between;border-bottom:0.5px solid #d2d2d2;padding-bottom:13px;align-items:flex-end;margin-bottom:13px;.title{font-weight:500;font-size:1.6rem;line-height:120%;color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.typo.subTitle;
});

var SidebarContent = _styledComponents.default.div.withConfig({
  displayName: "SidebarContent"
})(["display:", ";"], function (_ref4) {
  var open = _ref4.open;
  return open ? 'block' : 'none';
});

var SidebarToggle = _styledComponents.default.a.withConfig({
  displayName: "SidebarToggle"
})(["margin-left:2rem;font-size:1rem;line-height:120%;text-transform:uppercase;color:", ";cursor:pointer;&:hover{color:black;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

CollapsibleSidebar.propTypes = {
  /** Label to be displayed at the top. */
  label: _propTypes.string,

  /** Children to be displayed in the menu. */
  children: _propTypes.node,

  /** Initial opened or closed state */
  open: _propTypes.bool,

  /** If select  all should show instead of hide */
  selectAll: _propTypes.bool,

  /** The select all event */
  onSelectAllClick: _propTypes.func,

  /** The deselect all event */
  onDeselectAllClick: _propTypes.func,

  /** Are all fields selected */
  isAllSelected: _propTypes.bool,

  /** Content for hide text */
  hideText: _propTypes.string,

  /** Content for show text */
  showText: _propTypes.string,

  /** Content for select all text */
  selectAllText: _propTypes.string,

  /** Content for deselect all text */
  deselectAllText: _propTypes.string,

  /** Should button on the right be hidden */
  hideButton: _propTypes.bool
};
CollapsibleSidebar.defaultProps = {
  open: false
};
var _default = CollapsibleSidebar;
exports.default = _default;